import "./index.css";
import React from "react";
import Item from "./Item";
import { Button, Modal, ModalProps } from "antd";

interface TypeEditModalProps
  extends React.FC<
    {
      onInsert?(): void;
      description?: string;
    } & ModalProps
  > {
  Item: typeof Item;
}

/**
 * @name EditModal 编辑弹窗
 */
const EditModal: TypeEditModalProps = ({
  onInsert,
  children,
  className,
  description,
  ...props
}) => (
  <Modal
    open
    centered
    okText="Save"
    cancelButtonProps={{ className: "layout-modal-cancel" }}
    className={`layout-modal layout-form-data layout-modal-no-borer edit-website-modal ${
      className || ""
    }`}
    {...props}
  >
    {description ? <p className="edit-website-desc">{description}</p> : description}

    <div className="edit-website-list">
      {children}

      {onInsert ? (
        <Button onClick={onInsert} type="link" className="insert-website-item">
          Add more
        </Button>
      ) : null}
    </div>
  </Modal>
);

EditModal.Item = Item;

export default EditModal;
